import { HeaderSideImage, HeaderTextOverlay } from "./components";

export const Header = ({ className, title, description, img, back, bgColor, textColor, button, variant, align }) => {
  switch (variant) {
    case "50/50":
      return <HeaderSideImage className={className} title={title} description={description} img={img?.url} back={back} bgColor={bgColor} textColor={textColor} button={button} align={align} />;

    case "50/50 Reverse":
      return <HeaderSideImage className={className} title={title} description={description} img={img?.url} back={back} bgColor={bgColor} textColor={textColor} button={button} align={align} reverse />;

    case "Under Text":
    default:
      return <HeaderTextOverlay className={className} title={title} description={description} img={img?.url} back={back} bgColor={bgColor} textColor={textColor} button={button} align={align} />;
  }
};

export default Header;
